<template>
	<span class="label">{{ formattedCount }}</span>
</template>

<script>
export default {
	name: "CommentCount",
	props: {
		count: {
			type: [Number, String],
			required: true,
		},
	},
	computed: {
		formattedCount() {
			if (this.count >= 10000) {
				return `${(this.count / 10000).toFixed(1)}万+条评论`;
			} else {
				return `${this.count}条评论`;
			}
		},
	},
};
</script>

<style scoped lang="less">
.label {
	font-size: 22px;
	color: #323232;
}
</style>
